<template>
  <div class="widget survey">
    <b-row>
      <MonthControl
        :monthControl="monthControl"
        :prevInterval="prevQuestionInterval"
        :nextInterval="nextQuestionInterval"
        :currentInterval="currentQuestionInterval"
        @update="updateByQuestion"
      ></MonthControl>
    </b-row>
    <b-row>
      <b-col cols="12" md="7" class="chart">
        <ByQuestionGraph :data="chartData"></ByQuestionGraph>
      </b-col>
      <b-col cols="12" md="5">
        <RespondentListNew
          ref="respondent-list"
          :respondents="respondents"
          :showRespondants="showRespondants"
          :length="5"
          :allowReminding="allowReminding && periodName === currentPeriod"
        ></RespondentListNew>
      </b-col>
    </b-row>
    <b-row v-if="showComments">
      <b-col cols="12" class="widget-col">
        <div class="widget comment">
          <CommentList
            :chartData="chartData"
            :comments="comments"
            :projectId="projectId"
            :projectUsers="allProjectUsers"
            :presetTags="presetTags"
            @add="refreshProjectItems"
            @hide="hideComment"
            @unhide="unhideComment"
          ></CommentList>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import MonthControl from "@/components/survey/MonthControl.vue";
import ByQuestionGraph from "@/components/survey/ByQuestionGraph.vue";
import RespondentListNew from "@/components/survey/RespondentListNew.vue";
import CommentList from "@/sub-components/CommentList.vue";

export default {
  components: {
    MonthControl,
    ByQuestionGraph,
    RespondentListNew,
    CommentList,
  },
  props: {
    //Data
    comments: { type: Array, default: () => [] },
    periods: { type: Array, default: () => [] },
    selectedPeriod: { type: String, default: "" },
    projectId: { type: String, default: "" },
    allProjectUsers: { type: Array, default: () => [] },
    presetTags: { type: Array, default: () => [] },
    chartData: { type: Array, default: () => [] },
    //Options
    allowReminding: { type: Boolean, default: true },
    showComments: { type: Boolean, default: true },
    showRespondants: { type: Boolean, default: true },
    monthControl: { type: Boolean, default: true },
  },
  data() {
    // let period =
    //   this.periods.length > 0
    //     ? this.periods[this.periods.length - 1].periodName
    //     : "";

    let respondents =
      this.allProjectUsers.length > 0
        ? this.convertToRespondents(this.allProjectUsers)
        : [];

    return {
      periodName: this.selectedPeriod,
      currentPeriod: this.periods.length > 0 ? this.periods[this.periods.length - 1].periodName : "",
      respondents: respondents,
    };
  },
  methods: {
    refreshProjectItems(query) {
      this.$emit("refresh", query);
    },
    hideComment(index) {
      this.$emit("hide", index);
    },
    unhideComment(index) {
      this.$emit("unhide", index);
    },
    updateByQuestion(update) {
      // this.periodName = update.period;
      if (this.currentPeriod === update.period) {
        this.$refs["respondent-list"].filter("Has Not Responded");
      } else {
        this.$refs["respondent-list"].filter("Has Responded");
      }
      this.$emit("update", update);
    },
    convertToRespondents(allProjectUsers) {
      let respondents = allProjectUsers
        .filter((u) => u.responseData != null)
        .map((user) => ({
          ...user,
          isLoading: false,
          sent: false,
        }));
      let ordering = ["Owner", "Contractor"];
      respondents
        .sort((a, b) => (a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1))
        .sort((a, b) =>
          ordering.indexOf(a.role) < ordering.indexOf(b.role) ? -1 : 1
        );
      return respondents;
    },
  },
  watch: {
    periods(newVal) {
      if (newVal.length > 0) {
        // this.periodName = newVal[newVal.length - 1].periodName;
        this.currentPeriod = newVal[newVal.length - 1].periodName;
      }
    },
    selectedPeriod(val){
      this.periodName = val;
    },
    allProjectUsers(newVal) {
      this.respondents = this.convertToRespondents(newVal);
    },
  },
  computed: {
    nextQuestionInterval() {
      var index = this.periods
        .map((p) => p.periodName)
        .indexOf(this.periodName);
      return index === this.periods.map((p) => p.periodName).length - 1 ||
        index === -1
        ? null
        : this.periods[index + 1].periodName;
    },
    prevQuestionInterval() {
      var index = this.periods
        .map((p) => p.periodName)
        .indexOf(this.periodName);
      return index <= 0 ? null : this.periods[index - 1].periodName;
    },
    currentQuestionInterval() {
      var index = this.periods
        .map((p) => p.periodName)
        .indexOf(this.periodName);
      return index < 0 ? null : this.periods[index].periodName;
    },
  },
};
</script>